import React, { useState, createRef, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Route, Link  } from 'react-router-dom';
import { Redirect } from 'react-router';
import logo from '../../images/Logo.png';
import iconSearch from '../../images/icon-search.png';
import iconMenu from '../../images/icon-menu.png';
import introCertification from '../../images/introCertification.png';
import introReceipt from '../../images/introReceipt.png';
import introImgFragment from '../../images/introImgFragment.png';
import './style.css';
import introBgText from '../../images/introBgText.png';
import introductionLogo from '../../images/introductionlogo.png';
import { useRecoilState } from 'recoil'
import { ItemNameState, ItemPriceState, OptionsState, PostObjectState } from './atoms';
import { CartListState } from "../../Atoms/CartAtom";
import Select from "react-select"; //라이브러리 import
import { useRef } from 'react';
import ShowSlide from '../../Common/Component/SlideShowGallery';
import DaumPostcode from 'react-daum-postcode';

export default function BuyItem() {
    //원래는 select 태그 안에 들어가는 애들을 배열로 만들어준다.
    const inputFiles = useRef();
    const thumbnailImgRef = useRef();
    const PhotoSubmit = useRef(); // dom 에서 ref 기능으로 변경
  
    const [Name, setName] = useState('');
    const [PW, setPW] = useState('');
    const [Email, setEmail] = useState('');
    const [Phone1, setPhone1] = useState('');
    const [Phone2, setPhone2] = useState('');
    const [Phone3, setPhone3] = useState('');
    const [Address1, setAddress1] = useState('');
    const [Address2, setAddress2] = useState('');
    const [Address3, setAddress3] = useState('');
    const [deliveryName, setDeliveryName] = useState('');
    const [deliveryPhone1, setDeliveryPhone1] = useState('');
    const [deliveryPhone2, setDeliveryPhone2] = useState('');
    const [deliveryPhone3, setDeliveryPhone3] = useState('');

    const [Memo, setMemo] = useState('');
  
    const [radioAddress,setRadioAddress] = useState("2");
    const [radioLocation,setRadioLocation] = useState("1");
  
    const [TypeAdd, setTypeAdd] = useState('');
    const [itemColor, setItemColor] = useState([{ value: "default", label: "선택" }]);
    const [selectedOption, setSelectedOption] = useState({ value: "default", label: "선택" });
    const [option, setOption] = useRecoilState(OptionsState);
    const [uploadFile, setUploadFile] = useState();

    // const [count,setCount] = useState(0);
    // const [value, setValue] = useState(2);

  
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%', // 수정할 부분
    }),
  };

  const submitOrder = () => {
    //사진업로드 validation
    if (!Name) {
      alert('이름을 입력해주세요.');
      return;
    }
  
    if (!PW) {
      alert('결제비밀번호를 입력해주세요.');
      return;
    }
  
    if (!Email) {
      alert('이메일을 입력해주세요.');
      return;
    }
  
    if (!Phone1 || !Phone2 || !Phone3) {
      alert('휴대전화 번호를 입력해주세요.');
      return;
    }

  }

  // 게시글 목록 초기화
  const clearData = (i) => {
    PhotoSubmit.current.disabled = false;
    //inputFiles.value = null;
    document.getElementById("TextInput").value = null;
    thumbnailImgRef.current.src = null;
    thumbnailImgRef.current.width = '0';
    thumbnailImgRef.current.height = '0';
  }

  // 사진 업로드


  const uploadImgPreview = () => {
    let fileinfo = inputFiles.current.files[0];
    setUploadFile(fileinfo);

    let reader = new FileReader();
    reader.onload = function () {
      let image = new Image();
      image.onload = function () {
        // 이미지의 가로 세로 비율을 구합니다.
        let ratio = image.width / image.height;

        // 비율에 따라 썸네일의 크기를 조정합니다.
        if (ratio > 1) {
          // 가로가 세로보다 긴 경우
          thumbnailImgRef.current.width = 400;
          thumbnailImgRef.current.height = 400 / ratio;
        } else {
          // 세로가 가로보다 긴 경우 혹은 정사각형인 경우
          thumbnailImgRef.current.height = 400;
          thumbnailImgRef.current.width = 400 * ratio;
        }

        thumbnailImgRef.current.src = reader.result;
      }

      image.src = reader.result;
    }

    if (fileinfo) {
      reader.readAsDataURL(fileinfo);
    }
  }


  // 카운트 증가
  const initialItems = [
    { id: 'y1', value: 2, count: 0 },
    { id: 'y2', value: 2, count: 0 },
    { id: 'y3', value: 2, count: 0 },
    { id: 'y4', value: 2, count: 0 }
  ];
  const [itemsCount, setItemsCount] = useState(initialItems);
  const plusItem = (id) => {
    setItemsCount(
      itemsCount.map(item =>
        item.id === id && item.value > 0
          ? { ...item, value: item.value - 1, count: item.count + 1 }
          : item
      )
    );
  };
  const minusItem = (id) => {
    setItemsCount(
      itemsCount.map(item =>
        item.id === id && item.value <= 1
          ? { ...item, value: item.value + 1, count: item.count - 1 }
          : item
      )
    );
  };

  
    // 우편 코드 모달을 위한 state
    const [isPostcodeVisible, setIsPostcodeVisible] = useState(false);

    // Daum Postcode API에서 반환받은 주소 값을 설정
    const handlePostcodeComplete = (data) => {
      setAddress1(data.zonecode);
      setAddress2(data.address);
  
      setIsPostcodeVisible(false); // 모달 닫기
    };
  
    // 우편번호 찾기 버튼 클릭 시 모달 열기
    const openPostcodeModal = () => {
      setIsPostcodeVisible(true);
    };

    const [customMemo, setCustomMemo] = useState('');

    const [paymentMethod, setPaymentMethod] = useState('');
    const [easyPaymentMethod, setEasyPaymentMethod] = useState('');

  return (
    <>

<hr width='100%' color='#fff' />
<div className='OrderPage'>
  <div className='OrderTitle'>주문/결제</div>
      <div className='OrderList'>
        <div className='OrderSubTitle'>주문상품 총 22개</div>
          <table>
            <thead style={{borderBottom:'1px solid gray'}}>
              <tr>
              <th>상품정보</th>
              <th>수량</th>
              <th>가격</th>
              <th></th>
              </tr>
            </thead>
            <tbody>
                <tr style={{borderBottom:'1px solid lightgray'}}>
                <td style={{display:'flex'}}>
                  {/* 임의로 넣은 것이라 나중에 코드 바꿔야 함 */}
                  <img src="assets/fendi.jpg" style={{aspectRatio:'1/1', width:'200px'}}/>
                  <ul style={{listStyle:'none'}}>
                    <li>브랜드명</li>
                    <li style={{fontSize:'18px', fontWeight:'bold', marginTop:'10px'}}>상품명</li>
                    <li style={{fontSize:'15px', marginTop:'10px'}}>상품코드</li>
                    <li style={{fontSize:'15px'}}>옵션</li>
                  </ul>
                </td>
                <td style={{textAlign:'center'}}><div>상품수량</div>
                    <button className="quantitybutton">-</button>
                    <button className="quantitybutton">+</button>
                </td>
                <td style={{textAlign:'center'}}>1,000,000원</td>
                <td><button className="removebutton">삭제</button></td>
              </tr>             
            </tbody>
          </table>
        </div>

 
        <div className='OrderInfo'>

          <section className='InfoSection'>
          <div className='OrderSubTitle'>주문정보</div>
          <hr size="3" color="black"/>
          
          <div className='InfoContents'>
          <div className='InfoSubTitle'>주문자 정보</div>
            <table>
            <thead style={{borderBottom:'1px solid gray'}}>
              <tr>
              <th>이름</th>
              <th><input type='text' value={Name} onChange={(e)=>{setName(e.target.value)}}/></th>
              </tr>

              <tr>
              <th>결제비밀번호</th>
              <th><input type='password' value={PW} onChange={(e)=>{setPW(e.target.value)}}/></th>
              </tr>

              <tr>
              <th>이메일</th>
              <th><input type='email' value={Email} onChange={(e)=>{setEmail(e.target.value)}}/></th>
              </tr>
              
              <tr>
              <th>휴대전화</th>
              <th className='PhoneNum'>                    
    <div className="select-container">
        <select className="phone-select" value={Phone1} onChange={(e)=>{setPhone1(e.target.value)}}>
            <option value="010" selected>010</option>
            <option value="011">011</option>
            <option value="016">016</option>
            <option value="017">017</option>
            <option value="019">019</option>
        </select>
    </div>
    &nbsp;-&nbsp;
    {/* 첫 번째 전화번호 입력칸 */}
    <input 
        style={{width:"60px"}} 
        type='tel' 
        inputMode="tel"
        pattern="[0-9]*"
        onInput={(e)=>{
          const num = parseInt(e.target.value);
          e.target.value = isNaN(num) ? '' : Math.max(0, num).toString().slice(0,4);
       }}
       onChange={(e)=>{setPhone2(e.target.value)}}
    />
    &nbsp;-&nbsp;
    {/* 두 번째 전화번호 입력칸 */}
    <input 
        
        style={{width:"60px"}} 
        type='tel' 
        inputMode="numeric"
        pattern="[0-9]*"
        onInput={(e)=>{
          const num = parseInt(e.target.value);
          e.target.value = isNaN(num) ? '' : Math.max(0, num).toString().slice(0,4);
       }}
       onChange={(e)=>{setPhone3(e.target.value)}}
       />
</th>
        </tr>
            </thead>
            </table>
            </div>
            <hr size="1" color="lightgray"/>

            <div className='InfoContents'>
          <div className='InfoSubTitle'>배송지 정보</div>
            <table>
            <thead style={{borderBottom:'1px solid gray'}}>
              <tr>
              <th>배송지선택</th>
              <th>
                <div style={{display:'flex'}}>
                  <input type="radio" value="1" checked={radioAddress==="1"} 
                  onChange={(e)=>{setRadioAddress(e.target.value);
                  // 만약 "주문자 정보와 동일" 옵션이 선택되었다면,
                  // 배송지 정보를 주문자 정보로 설정합니다.
                  if (e.target.value === "1") {
                    setDeliveryName(Name);
                    setDeliveryPhone1(Phone1);
                    setDeliveryPhone2(Phone2);
                    setDeliveryPhone3(Phone3);
                  }
                }}/>
                  <div className='RadioContent'>주문자 정보와 동일</div>


              <input type="radio" value="2" checked={radioAddress==="2"} onChange={(e)=>setRadioAddress(e.target.value)}/><div className='RadioContent'>직접입력</div>
              </div>
              </th>
              </tr>
              <tr>
              <th>이름</th>
              <th>
              <input type='text' value={deliveryName} onChange={(e)=>{setDeliveryName(e.target.value)}}/></th>

              </tr>

              <tr>
              <th>주소</th>
              <th>                
                <div style={{display:'flex'}}>
                  <input type="radio" value="1" checked={radioLocation==="1"} onChange={(e)=>setRadioLocation(e.target.value)}/><div className='RadioContent'>국내</div>
                  <input type="radio" value="2" checked={radioLocation==="2"} onChange={(e)=>setRadioLocation(e.target.value)}/><div className='RadioContent'>해외</div>
                </div>
                <div>
             
        <div className='Address'>
         <input
          type='text'
          onChange={(e) => {
           setAddress1(e.target.value);
         }}
          style={{ width: '80px' }}
          value={Address1}
          readOnly
         />
        <button onClick={openPostcodeModal}>우편번호 찾기</button>
        </div>
  
  {/* 상세 주소 입력란 */}
  <div className='AddressDetail'>
    <input
      type='text'
      onChange={(e) => {
        setAddress2(e.target.value);
      }}
      style={{ width: '300px' }} // 원하는 너비로 조정하세요.
      value={Address2}
      placeholder="상세주소"
    />
  </div>

     {isPostcodeVisible && (
    <DaumPostcode
          onComplete={handlePostcodeComplete}
          autoClose
          width={500}
          height={500}
       />
     )}
  </div>  
               
                
       </th>
         </tr>
              <tr>
              <th>휴대전화</th>
              <th className='PhoneNum'>                    
    <div className="select-container">
        <select className="phone-select" value={deliveryPhone1} onChange={(e)=>{setDeliveryPhone1(e.target.value)}}>
            <option value="010" selected>010</option>
            <option value="011">011</option>
            <option value="016">016</option>
            <option value="017">017</option>
            <option value="019">019</option>
        </select>
    </div>
    &nbsp;-&nbsp;
    {/* 첫 번째 전화번호 입력칸 */}
    <input 
        style={{width:"60px"}} 
        type='text' 
        inputMode="numeric"
        pattern="[0-9]*"
        value={deliveryPhone2}
        onInput={(e)=>{
            e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,4)
        }}
        onChange={(e)=>{setDeliveryPhone2(e.target.value)}}
    />
    &nbsp;-&nbsp;
    {/* 두 번째 전화번호 입력칸 */}
    <input 
        style={{width:"60px"}} 
        type='text' 
        value={deliveryPhone3}
        inputMode="numeric"
        pattern="[0-9]*"
        onInput={(e)=>{
            e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,4)
         }}
         onChange={(e)=>{setDeliveryPhone3(e.target.value)}}
     />
</th>
           </tr>
           <tr>
    <th>배송메모</th>
    <th>
        <div className="select-container">
            <select className="Memo-select" onChange={(e)=>{setMemo(e.target.value)}}>
                <option value="text" selected>배송 시 요청사항을 선택해주세요</option>
                <option value="careful">부재시 경비실에 맡겨주세요</option>
                <option value="precious">집앞에 놔주세요</option>
                <option value="text">택배함에 놔주세요</option>
                <option value="text">문 앞에 두고 벨 눌러주세요</option>
                <option value="text">배송 전에 꼭 연락주세요</option>
                <option value="text">소중히 다뤄주세요</option>
                <option value="direct">직접 입력</option>  
                {Memo === "direct" && 
              (<input type='text' onChange={(e)=>{setCustomMemo(e.target.value)}}/>)
            }
            </select>
        </div>  
    </th>          
</tr>
            </thead>
            </table>
            </div>

            <hr size="1" color="lightgray"/> 

            <div className='InfoContents'>
            <div className='InfoSubTitle'>결제 수단</div>
  <div>
    <label>
      <input className="paymentoption"
        type="radio" 
        value="creditCard" 
        checked={paymentMethod === "creditCard"} 
        onChange={(e) => setPaymentMethod(e.target.value)}
      />
      간편결제
      {paymentMethod === "creditCard" && (
  <div>
    <label>
      <input 
        type="radio" 
        value="tossPay" 
        checked={easyPaymentMethod === "tossPay"} 
        onChange={(e) => setEasyPaymentMethod(e.target.value)}
      />
      토스페이
    </label>

    <label>
      <input 
        type="radio" 
        value="naverPay"
        checked={easyPaymentMethod === "naverPay"}  
        onChange={(e) => setEasyPaymentMethod(e.target.value)}
      />
      네이버페이
    </label>

    <label>
      <input 
        type="radio" 
        value="payco"
        checked={easyPaymentMethod === "payco"}  
        onChange={(e) => setEasyPaymentMethod(e.target.value)}
      />
     페이코
    </label>

     {/* 필요한 만큼 추가적인 결제 방법 옵션을 추가하세요 */}
     <label>
       <input
         type='radio'
         value='kakaoPay'
         checked={easyPaymentMethod === 'kakaoPay'}
         onChange={(e)=>setEasyPaymentMethod(e.target.value)}
       />
       카카오페이
     </label>     
  </div>    
)}   
    </label>

    <label>
      <input 
        type="radio" 
        value="debitCard"
        checked={paymentMethod === "debitCard"}  
        onChange={(e) => setPaymentMethod(e.target.value)}
      />
      카드결제
    </label>

    <label>
      <input 
        type="radio" 
        value="paypal"
        checked={paymentMethod === "paypal"}  
        onChange={(e) => setPaymentMethod(e.target.value)}
      />
     휴대폰결제
    </label>
            </div>
            </div>
          </section>
          <aside>
          <div className="OrderRight">
            <div className="OrderRightbox">
            <div style={{padding:'30px'}}>결제금액</div>
            <div style={{fontSize:'30px', fontWeight:'bold', textAlign:'center'}}>1,000,000<span style={{fontSize:'20px'}}> 원</span></div>
          </div>
          <Link to={{pathname: '/pay',state: { cart:'' }}}> <button onClick={() => submitOrder()}>결제하기</button></Link>
          </div>
          </aside>
        </div>
        </div>
    </>
  );
}


